import React from 'react'
import {ActivityFeed, TabHeader} from '@/ui/index'
import {Tab} from '@/types/components'

export function ProjectActivity(props: Tab) {
  return <ActivityFeed header={<TabHeader {...props} title="Project activity" />} />
}
